import datastore from "../store/hoa-datastore";
import config from "../hoa-config";
import { notificationTypeValuePopulate, renderPeriod } from "./../utility/helper";

//* For Restricted Data some data are restricted here and Amenities are restricted in 
//* Amenities Components and for violation Restricted Mandatory and Regulated field are restricted in tab-item-component

const clientInfoHoa: any = (hoaClientInfo: any) => {
	if (!hoaClientInfo) return [];

	let clientInformation: any = [];

	hoaClientInfo.map((client: any) => {
		if (datastore.userRole === config.userRoles.OrganizationUser) {
			if (datastore.selectedOrganization?.id == "XhZBTB9mDM") {
				if (["XhZBTB9mDM", "cSzprl5nZN"].includes(client.clientId)) {
					clientInformation.push({
						clientName: client.clientName,
						vendorID: client?.value ? client?.value : "N/A",
					});
				}
			}
			else if (client.clientId === datastore.selectedOrganization?.id) {
				clientInformation.push({
					clientName: client.clientName,
					vendorID: client?.value ? client?.value : "N/A",
				});
			}
		} else {
			clientInformation.push({
				clientName: client.clientName,
				vendorID: client?.value ? client?.value : "N/A",
			});
		}
	});

	return [
		{
			clientInformation: clientInformation,
		},
	];
};

const masterHoaInformation = (masterHoa: any) => {
	if (!masterHoa) return [];

	return [
		{
			"HOA Name": masterHoa["name"] || "N/A",
			"HOA Address": masterHoa["address"] || "N/A",
			ID: masterHoa["objectId"],
			Market: masterHoa.municipality["market"] || "N/A",
			City: masterHoa.municipality["city"] || "N/A",
			Zip: masterHoa["zip"] || "N/A",
			State: masterHoa.municipality["state"] || "N/A",
			"Phone number": masterHoa.phone || "N/A",
			Email: masterHoa.email || "N/A",
		},
	];
};

const preferredViolationRemediation = (violationRegulations: any) => {
	if (!violationRegulations) return [];

	const output: any = [];

	violationRegulations?.preferredViolationRemediation?.map((title: any) => {
		let tmp: any = {};
		tmp[title] = violationRegulations[config.preferredViolationRemediation[title]] || "N/A";
		output.push(tmp);
	});

	return output;
};

const dataMappingWithRegulations = (options: any, violationRegulations: any, type: string) => {
	if (!options || options?.length === 0) return [];

	let output: any = [];
	options.map((option: any) => {
		const regulation = config.violationRegulations[option] || "";

		output.push({
			option: option,
			regulation: regulation ? violationRegulations[type][regulation] || "" : "",
		});
	});
	return output;
};

const trashGrassTypeOptions = (selectedValues: any) => {
	const allowedTypesOfGrass = 
		selectedValues["violationRegulations"]?.["landscaping"]?.allowedTypesOfGrass || [];
	const restrictedTypesOfGrass = 
		selectedValues["violationRegulations"]?.["landscaping"]?.restrictedTypesOfGrass || [];

	const output: any = {};

	if (selectedValues["violationRegulations"]?.["landscaping"]?.grassTypeRegulations) {
		output["Allowed Grass Types"] = allowedTypesOfGrass;
		output["Restricted Grass Types"] = restrictedTypesOfGrass;
	}
	
	return output;
};

const timeOfPlaceGarbageCans = (selectedValues: any) => {
	if (selectedValues["violationRegulations"]?.["trash"]?.hour) {
		return `${selectedValues["violationRegulations"]?.["trash"]?.hour || 0} Hours`;
	}
	const time: any = {
		...((selectedValues["violationRegulations"]?.["trash"]?.fromTimeSelection ||
			selectedValues["violationRegulations"]?.["trash"]?.fromDaySelection) && {
			From: `${
				selectedValues["violationRegulations"]?.["trash"]?.fromTimeSelection === "Time"
					? selectedValues["violationRegulations"]?.["trash"]?.fromHour
					: selectedValues["violationRegulations"]?.["trash"]?.fromTimeSelection
			} ${
				selectedValues["violationRegulations"]?.["trash"]?.fromTimeSelection &&
				selectedValues["violationRegulations"]?.["trash"]?.fromDaySelection
					? "on"
					: ""
			} ${selectedValues["violationRegulations"]?.["trash"]?.fromDaySelection}`,
		}),
		...((selectedValues["violationRegulations"]?.["trash"]?.toTimeSelection ||
			selectedValues["violationRegulations"]?.["trash"]?.toDaySelection) && {
			To: `${
				selectedValues["violationRegulations"]?.["trash"]?.toTimeSelection === "Time"
					? selectedValues["violationRegulations"]?.["trash"]?.toHour
					: selectedValues["violationRegulations"]?.["trash"]?.toTimeSelection
			} ${
				selectedValues["violationRegulations"]?.["trash"]?.toTimeSelection &&
				selectedValues["violationRegulations"]?.["trash"]?.toDaySelection
					? "on"
					: ""
			} ${selectedValues["violationRegulations"]?.["trash"]?.toDaySelection}`,
		}),
	};

	if (!time.From && !time.To) return "N/A";

	return `From: ${time.From} To:${time.To}`;
};

const prohibitedVehicles = (prohibitedVehicles: any) => {
	if (!prohibitedVehicles) return [];

	const content: string = prohibitedVehicles || "";
	let values: string = "";
	if (content.includes(",")) {
		values = content.replace(/\n/g, "").split(",").join(",");
	} else {
		values = content.replace(/\n/g, ",");
	}
	const temp = values.trim();
	if (temp.endsWith(",")) {
		values = temp.slice(0, -1);
	}

	const output = values.replace(/\b\w/g, (value:any) => value.toUpperCase())

	return output.split(",");
};

export const getViolationDetails = (selectedValues: any) => {
	const violationDetails: any = {
		"Basic Information": [
			{
				"Violation Fees (min)":
					`$${selectedValues["violationRegulations"]?.minViolationFees || 0}` || "N/A",
				"Violation Fees (max)":
					`$${selectedValues["violationRegulations"]?.maxViolationFees  || 0}` || "N/A",
				"Cure Period": renderPeriod(
					selectedValues["violationRegulations"]?.curePeriod,
					selectedValues["violationRegulations"]?.timeline
				),
				"Notification Type": notificationTypeValuePopulate(
					selectedValues["violationRegulations"]?.notificationType
				),
				"Violation Payment":
					selectedValues["violationRegulations"]?.violationPayment || "N/A",
			},
		],
		"Preferred Violation Remediation": preferredViolationRemediation(
			selectedValues["violationRegulations"]
		),
		"Other Restriction in Place and Fees": [
			{
				"Grace Period": renderPeriod(
					selectedValues["violationRegulations"]?.gracePeriod,
					selectedValues["violationRegulations"]?.graceTimeline
				),
				"Assessment Frequency":
					selectedValues["violationRegulations"]?.assessmentFrequency || "N/A",
				"Assessment Fee": selectedValues["violationRegulations"]?.assessmentFee || "N/A",
				"Assessment Violation Fee":
					selectedValues["violationRegulations"]?.assessmentViolationFee || "N/A",
				"Additional Information":
					selectedValues["violationRegulations"]?.assessmentViolationFeeAdditionalInfo ||
					"N/A",
			},
		],
	};

	const ViolationTabsDetails = {
		Landscaping: {
			"Grass Trimming": [
				{
					"Assessment Frequency":
						`${
							selectedValues["violationRegulations"]?.["landscaping"]
								?.assesmentFrequency
								? "Every"
								: ""
						} ${
							selectedValues["violationRegulations"]?.["landscaping"]
								?.assesmentFrequency
						} ${
							selectedValues["violationRegulations"]?.["landscaping"]?.timeline || ""
						}` || "N/A",
					"Acceptable Height Of Grass":
						`${
							selectedValues["violationRegulations"]?.["landscaping"]
								?.acceptableHeightOfGrass
						} ${
							selectedValues["violationRegulations"]?.["landscaping"]?.grassSize || ""
						}` || "N/A",
					"Regulations":
						selectedValues["violationRegulations"]?.["landscaping"]
						?.grassTrimmingRegulations || "N/A",
				},
				{
					"Grass Type Additional Info":
						selectedValues["violationRegulations"]?.["landscaping"]
							?.grassTypeAdditionalInfo || "N/A",
				},
				trashGrassTypeOptions(selectedValues),
			],
			"Trees & Shrubbing": [
				{
					"Height Of Canopy":
						`${selectedValues["violationRegulations"]?.["landscaping"]?.canopyHeight} ${
							selectedValues["violationRegulations"]?.["landscaping"]?.canopySize ||
							""
						}` || "N/A",
				},
				{
					Restricted: dataMappingWithRegulations(
						selectedValues["violationRegulations"]?.["landscaping"]?.restrictedOptions,
						selectedValues["violationRegulations"],
						"landscaping"
					),
				},
			],
			"Soil Erosion": [
				{
					Mandatory: dataMappingWithRegulations(
						selectedValues["violationRegulations"]?.["landscaping"]?.mandatoryOptions,
						selectedValues["violationRegulations"],
						"landscaping"
					),
				},
			],
		},
		Trash: {
			"Storage of Trash": [
				{
					Restricted: dataMappingWithRegulations(
						selectedValues["violationRegulations"]?.["trash"]?.storageOfWaste,
						selectedValues["violationRegulations"],
						"trash"
					),
				},
			],
			"Visible Waste": [
				{
					Restricted: dataMappingWithRegulations(
						selectedValues["violationRegulations"]?.["trash"]?.visibleWaste,
						selectedValues["violationRegulations"],
						"trash"
					),
				},
			],
			"Trash Collection": [
				{
					Mandatory: dataMappingWithRegulations(
						selectedValues["violationRegulations"]?.["trash"]
							?.isSpecificGarbageCansMandatory
							? ["Specific garbage cans for trash collection"]
							: [],
						selectedValues["violationRegulations"],
						"trash"
					),
				},
				{
					"Types of Cans":
						selectedValues["violationRegulations"]?.["trash"]?.typesOfTrashCans ||
						"N/A",
				},
				{
					"Time of Placing Garbage Cans": timeOfPlaceGarbageCans(selectedValues),
				},
				{
					"Regulations": 
						selectedValues["violationRegulations"]?.["trash"]?.regulationOfTimeOfPlacingGarbageCans ||
						"N/A",
				}
			],
		},
		Parking: {
			"Street Parking": [
				{
					"Time Limit for Street Parking":
						selectedValues["violationRegulations"]?.["parking"]
							?.timeLimitForStreetParking || "N/A",
					"Street Parking - Speed limit inside HOA":
						selectedValues["violationRegulations"]?.["parking"]?.speedLimitInsideHoa ||
						"N/A",
				},
				{
					Mandatory: dataMappingWithRegulations(
						selectedValues["violationRegulations"]?.["parking"]
							?.priorApprovalNeededForStreetParking === true
							? ["Prior Approval Needed for Street Parking"]
							: [],
						selectedValues["violationRegulations"],
						"parking"
					),
				},
				{
					"Street parking is not allowed":
						selectedValues["violationRegulations"]?.["parking"]
							?.isStateParkingNotAllowed == true
							? "Yes"
							: "No" || "N/A",
					"Type of cars not allowed":
						selectedValues["violationRegulations"]?.["parking"]?.notAllowedCarTypes ||
						"N/A",
				},
			],
			"Driveway Parking": [
				{
					"Number of Cars Allowed On Lot":
						selectedValues["violationRegulations"]?.["parking"]?.numberOfCarsAllowedOnLot ||
						"N/A",
					Regulation:
						selectedValues["violationRegulations"]?.["parking"]
							?.regulationsOfnumberOfCarsAllowed || "N/A",
				},
				{
					"Garage Capacity":
						selectedValues["violationRegulations"]?.["parking"]?.garageCapacity ||
						"N/A",
					Regulation:
						selectedValues["violationRegulations"]?.["parking"]
							?.regulationsOfgarageCapacity || "N/A",
				},
				{
					Restricted: dataMappingWithRegulations(
						selectedValues["violationRegulations"]?.["parking"]
							?.drivewayParkingRestrictedOptions,
						selectedValues["violationRegulations"],
						"parking"
					),
				},
			],
			"Unlicensed Vehicle": [
				{
					Restricted: dataMappingWithRegulations(
						selectedValues["violationRegulations"]?.["parking"]
							?.unlicensedVehicleRestrictedOptions,
						selectedValues["violationRegulations"],
						"parking"
					),
				},
				{
					"Prohibited Vehicles": {
						vehicles: selectedValues["violationRegulations"]?.["parking"]
							?.prohibitedVehicles
							? prohibitedVehicles(
									selectedValues["violationRegulations"]?.["parking"]
										?.prohibitedVehicles
							  )
							: [],
						regulation:
							selectedValues["violationRegulations"]?.["parking"]
								?.regulationsOfProhibitedVehicle,
					},
				},
			],
		},
		Nuisance: {
			"Loud Residents": [
				{
					"Allowed Occupancy Of Guests":
						selectedValues["violationRegulations"]?.["nuisance"]
							?.allowedOccupancyOfGuests || "N/A",
					Regulation:
						selectedValues["violationRegulations"]?.["nuisance"]
							?.regulationsOfGuests || "N/A",
				},
				{
					Restricted: dataMappingWithRegulations(
						selectedValues["violationRegulations"]?.["nuisance"]
							?.loudResidentsRestrictedOptions,
						selectedValues["violationRegulations"],
						"nuisance"
					),
				},
			],
			"Animals": [
				{
					Restricted: dataMappingWithRegulations(
						selectedValues["violationRegulations"]?.["nuisance"]
							?.loudAnimalsRestrictedOptions,
						selectedValues["violationRegulations"],
						"nuisance"
					),
				},
			],
			"Offensive Behaviors": [
				{
					Restricted: dataMappingWithRegulations(
						selectedValues["violationRegulations"]?.["nuisance"]
							?.offensiveBehaviorRestrictedOptions,
						selectedValues["violationRegulations"],
						"nuisance"
					),
				},
			],
		},
		Structure: {
			Alteration: [
				{
					Regulated: dataMappingWithRegulations(
						selectedValues["violationRegulations"]?.["structure"]
							?.regulatedAlterationsOptions,
						selectedValues["violationRegulations"],
						"structure"
					),
				},
			],
			Building: [
				{
					"Structure change application form": "",
					Documents:
						selectedValues["violationRegulations"]?.["structure"]?.structureChangeFiles,
					"Structure Hyper Link":
						selectedValues["violationRegulations"]?.["structure"]?.buildingOptions
							?.structureHyperLink,
				},
				{
					"Planning & Building department Details": "",
					Email:
						selectedValues["violationRegulations"]?.["structure"]?.buildingOptions
							?.email || "N/A",
					Phone:
						selectedValues["violationRegulations"]?.["structure"]?.buildingOptions
							?.phone || "N/A",
				},
				{
					"Architectural Instructions":
						selectedValues["violationRegulations"]?.["structure"]?.buildingOptions
							?.instructions || "N/A",
				},
			],
			Maintenance: [
				{
					Regulated: dataMappingWithRegulations(
						selectedValues["violationRegulations"]?.["structure"]
							?.regulatedMaintenanceOptions,
						selectedValues["violationRegulations"],
						"structure"
					),
				},
			],
		},
		Others: {
			others: [
				{
					others: selectedValues["violationRegulations"]?.others || "N/A",
				},
			],
		},
	};
	const ViolationDetails = RestrictedFields(violationDetails, "violation");
	const violationTabsDetails = RestrictedFieldForViolationTabs(ViolationTabsDetails);
	return { ViolationDetails, violationTabsDetails };
};

export const getOverViewDetails = (selectedValues: any) => {
	const overViewDetails: any = {
		"Basic Information": [
			{
				ID: selectedValues["objectId"],
				Market: selectedValues["market"] || "N/A",
				Zip: selectedValues["zip"] || "N/A",
				Coordinates: selectedValues["coordinates"] || "N/A",
				"Contact Number": selectedValues["phone"] || "N/A",
				"Email": selectedValues["email"] || "N/A",
			},
			{
				"HOA Fees": selectedValues["fees"] || 0,
				"Payment Frequency": selectedValues["paymentFrequency"] || "N/A",
				"HOA Fees Payment Deadline": selectedValues["hoaFeesPaymentDeadline"] || "N/A",
				"HOA Payment Information":
					selectedValues["hoaPaymentInformation"] || "N/A",
			},
			{
				"Board Meeting Schedule": selectedValues["boardMeetingSchedule"] || "N/A",
			},
			{
				"Property Manager Name":
					selectedValues["propertyManager"]?.propertyManagerName || "N/A",
				"Property Manager Company Address":
					selectedValues["propertyManager"]?.propertyManagerCompanyAddress || "N/A",
				"Property Manager Phone":
					selectedValues["propertyManager"]?.propertyManagerPhone || "N/A",
				"Property Manager Email":
					selectedValues["propertyManager"]?.propertyManagerEmail || "N/A",
			},
		],
		Municipality: [
			{
				Name: selectedValues["municipality"].name || "N/A",
				Market: selectedValues["market"] || "N/A",
				City: selectedValues["municipality"].city || "N/A",
				State: selectedValues["municipality"].state || "N/A",
				Zip: selectedValues["municipality"]?.zip?.split(",") || "N/A",
			},
		],
		"Master HOA Information": masterHoaInformation(selectedValues?.masterHoa),
		"Additional information": [
			{
				"Gate Access Requirement": selectedValues["residentGateAccessRequirement"] || "N/A",
			},
			{
				"Gated Area": selectedValues["isGateAccessRequired"] ? "Yes" : "No",
				"Guest Access": selectedValues["guestAccessPermission"]
					? selectedValues["guestAccessPermission"]
					: "N/A",
				"Gate Access Form": 
					selectedValues?.gateAccessFormFiles?.length > 0 ? selectedValues?.gateAccessFormFiles : [],
				"Portal Access": selectedValues["isPortalAccessRequired"] ? "Yes" : "No",
				"Resident login": selectedValues["residentLoginAvailable"]
					? "Available"
					: "Not available",
				"HOA Portal link": selectedValues["hoaPortalLink"] || "N/A",
				"PMC Portal link": selectedValues["pmcPortalLink"] || "N/A",
			},
			{
				"Community Services": selectedValues?.communityServices || [],
			},
		],
		"Client Information": clientInfoHoa(selectedValues?.hoaClientInfo),
		"HOA Events": selectedValues?.hoaEvents || []
	};
	return RestrictedFields(overViewDetails, "overview");
};

export const getProcedureDetails = (selectedValues: any) => {
	const { procedures } = selectedValues;
	const ProcedureDetails = {
		"HOA Registration Renewal Information": [
			{
				"Registration & Renewal Instructions": procedures.registrationAndRenewalInstruction || "N/A",
			},
			{
				"Renewal Fee": `$${procedures.renewalFee || ""}` || "N/A",
				"Additional Information": procedures.AdditionalInformationOfRenewalFee || "N/A",
			},
		],
		"HOA Leasing Regulations And Restrictions": [
			{
				"Leasing Regulations And Restrictions":
					procedures.leasingRegulationsAndRestrictions || "N/A",
				Categories: procedures?.categories?.length > 0 ? procedures.categories : [],
				"Source Documents":
					procedures?.sourceDocuments?.length > 0 ? procedures?.sourceDocuments : [],
				Reference: procedures.reference || "N/A",
			},
			{
				"Leasing Cap": procedures.leasingCap ? "Available" : "Not Available",
				"Additional Information": procedures.AdditionalInformationOfLeasingCap || "N/A",
			},
			{
				"Effective Date of Leasing Restriction": procedures.leasingRestrictionDate
					? new Date(procedures.leasingRestrictionDate).toLocaleDateString()
					: "N/A",
				"Additional Information": procedures.AdditionalInformationOfDateOfLeasing || "N/A",
			},
			{
				"Registrations Admin Fee": procedures.registrationAddminFee || "N/A",
				"Tenant or Lease Registration/Renewal Form": procedures.tenantLeaseRegistrationRenewalForm || "",
			},
		],
	};

	return RestrictedFields(ProcedureDetails, "procedure");
};

export const getAmenitiesDetails = (selectedValues: any) => {
	const AmenitiesDetails = {
		amenityEvents: selectedValues?.amenityEvents || [],
		newAvailableAmenities: selectedValues?.newAvailableAmenities || [],
		accessInformation: selectedValues?.accessInformation || [],
	};

	return AmenitiesDetails;
};

const RestrictedFields = (details: any, type: string) => {
	if(Object.keys(datastore.selectedConfiguration).length === 0) return details;

	if (type === "overview") {
		const sections = ["Basic Information", "Additional Information", "Client Information"];

		sections.forEach((section) => {
			if (details[section]) {
				if (
					section === "Client Information" &&
					datastore.notVisibleItemOfOverview[section].length > 0
				) {
					delete details[section];
				} else {
					details[section].forEach((info: any) => {
						datastore.notVisibleItemOfOverview[section].forEach((item: any) => {
							delete info[item];
						});
					});
				}
			}
		});
	} else if (type === "procedure") {
		const sections = [
			"HOA Registration Renewal Information",
			"HOA Leasing Regulations And Restrictions",
		];
		sections.forEach((section) => {
			details[section].forEach((info: any) => {
				datastore.notVisibleItemOfProcedure[section].forEach((item: any) => {
					delete info[item];
				});
			});
		});
	} else if (type === "violation") {
		details["Basic Information"].forEach((info: any) => {
			datastore.notVisibleItemOfViolation["Basic Information"].forEach((item: any) => {
				delete info[item];
			});
		});

		details["Other Restriction in Place and Fees"].forEach((info: any) => {
			datastore.notVisibleItemOfViolation["Other Restriction in Place and Fees"].forEach(
				(item: any) => {
					delete info[item];
				}
			);
		});

		details["Preferred Violation Remediation"].forEach((info: any) => {
			let temp: any = details["Preferred Violation Remediation"] || [];
			datastore.notVisibleItemOfViolation["Basic Information"].forEach((item: any) => {
				if (item == "Email" || item === "Portal" || item === "Other") {
					temp = temp.filter((obj: any) => !obj.hasOwnProperty(item));
				}
			});
			details["Preferred Violation Remediation"] = temp;
		});
	}

	return details;
};

const RestrictedFieldForViolationTabs = (details: any) => {
	if(Object.keys(datastore.selectedConfiguration).length === 0) return details;

	["Grass Trimming", "Trees & Shrubbing", "Soil Erosion"].forEach((section: string) => {
		details.Landscaping[section].forEach((info: any) => {
			datastore.notVisibleItemOfViolationTab["Landscaping"].forEach((item: any) => {
				if (item === "Artificial Grass On Property") {
					delete info["Artificial grass on property"];
					delete info["Regulation"];
				}
				if (item === "Marked Grass Type") {
					delete info["Allowed Grass Types"];
					delete info["Not Allowed Grass Types"];
					delete info["N/A Grass Types"];
				}
				if (item === "Canopy Measurements") {
					delete info["Height Of Canopy"];
					delete info["Regulation"];
				}
				delete info[item];
			});
		});
	});

	["Storage of Trash", "Visible Waste", "Trash Collection"].forEach((section: string) => {
		details.Trash[section].forEach((info: any) => {
			datastore.notVisibleItemOfViolationTab["Trash"].forEach((item: any) => {
				if (item === "Specific Garbage Cans") {
					datastore.notVisibleItemOfViolationTab["Trash"].push(
						"Specific garbage cans for trash collection"
					);
					delete info["Types of Cans"];
				}
				delete info[item];
			});
		});
	});

	["Street Parking", "Driveway Parking", "Unlicensed Vehicle"].forEach((section: string) => {
		details.Parking[section].forEach((info: any) => {
			datastore.notVisibleItemOfViolationTab["Parking"].forEach((item: any) => {
				if(item === 'Time Limit For Street Parking') {
					delete info['Time Limit for Street Parking']
				}
				if(item === 'Prior Approval Needed For Street Parking') {
					datastore.notVisibleItemOfViolationTab["Parking"].push('Prior Approval Needed for Street Parking')
				}
				if(item === 'Speed Limit Inside HOA') {
					delete info['Street Parking - Speed limit inside HOA']
				}

				if(item === 'Numbers Of Cars Allowed On Lot') {
					delete info['Number of Cars Allowed On Lot']
					delete info['Regulation']
				}

				if(item === 'Garage Capacity') {
					delete info['Garage Capacity']
					delete info['Regulation']
				}

				if(item === 'Prohibited Vehicles') {
					delete info['Prohibited Vehicles']
					delete info['Regulation']
				}

				delete info[item]
			});
		});
	});

	["Loud Residents", "Animals", "Offensive Behaviors"].forEach((section: string) => {
		details.Nuisance[section].forEach((info: any) => {
			datastore.notVisibleItemOfViolationTab["Nuisance"].forEach((item: any) => {
				if(item === 'Allowed Occupancy Of Guests') {
					delete info['Allowed Occupancy Of Guests']
					delete info['Regulation']
				}
				
				delete info[item]
			});
		});
	});

	["Alteration", "Building", "Maintenance"].forEach((section: string) => {
		details.Structure[section].forEach((info: any) => {
			datastore.notVisibleItemOfViolationTab["Structure"].forEach((item: any) => {
				if(item === 'Email Address') {
					delete info['Email']
				}
				if(item === 'Phone Number') {
					delete info['Phone']
				}
				if(item === 'Structure Change Files') {
					delete info['Documents']
				}
				if(item === 'Architectural Files') {
					delete info['Documents']
				}
				delete info[item]
			});
		});
	});

	if(datastore.notVisibleItemOfViolationTab['Others']?.length > 0) {
		details.Others = {}
	}

	return details;
};
